import { BaseService } from 'core/services';
import InsuranceRouteService from './InsuranceRouteService';

class InsuranceService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new InsuranceRouteService());
    }

    getDownloadUrl(filter){
        return this.apiClient.appOptions.apiUrl + this.routeService.download(filter);
    }

    async upload(resource) {
        var formData = new FormData();
        formData.append('file', resource.file);  
        const url = this.routeService.upload(formData);
        const response = await this.apiClient.post(url, formData);
        return response.data || null;
    }

    async sync(){
        const url = this.routeService.sync();
        const response = await this.apiClient.put(url);
        return response.data || null;
    }

    async nikoSync(){
        const url = this.routeService.nikoSync();
        const response = await this.apiClient.put(url);
        return response.data || null;
    }
}

export default InsuranceService;
